// extracted by mini-css-extract-plugin
module.exports = {"panelling":"style_panelling__31PTY","bgg":"style_bgg__3QfIN","wrapp":"style_wrapp__3U38s"};